<template>
  <header>
    <nav :class="['navbar navbar-expand-lg fixed-top fitsi-nav', { 'nav-scrolled': isScrolled }]">
      <div class="container-fluid px-3 px-sm-4 px-lg-5">
        <!-- Logo de The Fit Bar (Esquina Izquierda) -->
        <a class="navbar-brand d-flex align-items-center gap-3 py-0" href="#inicio" @click="clickNav(1)">
          <img
            :src="require('@/assets/img/logo.jpeg')"
            alt="The Fit Bar Cancún"
            width="68"
            height="68"
            class="rounded-circle brand-logo shadow-sm"
          />
          <div class="d-none d-sm-block lh-1">
            <span class="d-block fw-bold text-white brand-name">THE FIT BAR</span>
            <span class="d-block text-naranja brand-subtitle">HEALTHY & GOURMET</span>
          </div>
        </a>

        <!-- Botón Hamburguesa Móvil -->
        <button
          class="navbar-toggler border-0 shadow-none p-1 ms-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="bi bi-list text-white fs-1"></i>
        </button>

        <!-- Enlaces de Navegación y Botón (Esquina Derecha) -->
        <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul class="navbar-nav align-items-lg-center gap-lg-3 gap-2 mt-3 mt-lg-0">
            <li class="nav-item">
              <a
                class="nav-link custom-link"
                :class="{ active: activeSection === 'inicio' }"
                @click="clickNav(1)"
                href="#inicio"
              >INICIO</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link custom-link"
                :class="{ active: activeSection === 'favoritos' }"
                @click="clickNav(2)"
                href="#favoritos"
              >FAVORITOS</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link custom-link"
                :class="{ active: activeSection === 'menu' }"
                @click="clickNav(3)"
                href="#menu"
              >MENÚ FIT</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link custom-link"
                :class="{ active: activeSection === 'delivery' }"
                @click="clickNav(4)"
                href="#delivery"
              >DELIVERY</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link custom-link"
                :class="{ active: activeSection === 'contacto' }"
                @click="clickNav(5)"
                href="#contacto"
              >UBICACIÓN</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link custom-link"
                href="https://thefitgym.mx/"
                target="_blank"
                rel="noopener noreferrer"
              >FITGYM</a>
            </li>
            <li class="nav-item ms-lg-2">
              <a
                href="https://api.whatsapp.com/send?phone=9983641651&text=%C2%A1Hola%20The%20Fit%20Bar!%20%F0%9F%8D%BD%EF%B8%8F%20Quiero%20hacer%20un%20pedido"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-nav-cta rounded-pill px-4 py-2 d-inline-flex align-items-center gap-2"
              >
                <i class="bi bi-whatsapp"></i>
                <span>PEDIR POR WHATSAPP</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Nav_fitbar",
  data() {
    return {
      activeSection: "inicio",
      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.handleScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const top = window.scrollY || document.documentElement.scrollTop;
      if (!this.isScrolled && top > 50) {
        this.isScrolled = true;
      } else if (this.isScrolled && top < 20) {
        this.isScrolled = false;
      }
    },
    clickNav(tipo) {
      const navElement = document.getElementById("navbarNav");
      if (navElement && navElement.classList.contains("show")) {
        navElement.classList.remove("show");
      }

      if (tipo === 1) this.activeSection = "inicio";
      if (tipo === 2) this.activeSection = "favoritos";
      if (tipo === 3) this.activeSection = "menu";
      if (tipo === 4) this.activeSection = "delivery";
      if (tipo === 5) this.activeSection = "contacto";
    },
  },
};
</script>

<style scoped>
/* ====================================================================
   Navbar Estilo Fitgym: Esquinas completas, oscuro con blur sin parpadeo
   ==================================================================== */
.fitsi-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1050;
  background: rgba(10, 10, 10, 0.92);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  /* Capa de composición GPU para evitar parpadeos al hacer scroll */
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  will-change: transform, background-color, box-shadow;
  transition: background-color 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease, padding 0.25s ease;
}

.fitsi-nav.nav-scrolled {
      background: rgb(7 15 21 / 80%);
    border-bottom: 1px solid rgba(253, 111, 60, 0.35);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.85);
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
}

.brand-logo {
  width: 68px;
  height: 68px;
  object-fit: cover;
  border: 2.5px solid #fd6f3c;
  box-shadow: 0 0 16px rgba(253, 111, 60, 0.35);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.brand-logo:hover {
  transform: scale(1.06);
  box-shadow: 0 0 22px rgba(253, 111, 60, 0.6);
}

.fitsi-nav.nav-scrolled .brand-logo {
  width: 58px;
  height: 58px;
}

.brand-name {
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  font-size: 1.3rem;
  letter-spacing: 0.05em;
}

.brand-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  margin-top: 3px;
}

.text-naranja {
  color: #fd6f3c !important;
}

/* Enlaces estilo Fitgym */
.custom-link {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.88rem;
  letter-spacing: 0.08em;
  color: #e5e5e5 !important;
  transition: color 0.25s ease, transform 0.25s ease;
  padding: 0.4rem 0.6rem !important;
}

.custom-link:hover,
.custom-link.active {
  color: #fd6f3c !important;
  transform: translateY(-1px);
}

/* Botón CTA estilo Fitgym */
.btn-nav-cta {
  background: #fd6f3c;
  color: #ffffff !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 0.06em;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(253, 111, 60, 0.4);
}

.btn-nav-cta:hover {
  background: #ffffff;
  color: #fd6f3c !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 255, 255, 0.35);
}

/* Menú responsivo para móviles */
@media (max-width: 991px) {
  .navbar-collapse {
    background: rgba(14, 14, 14, 0.98);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 1.25rem;
    margin-top: 0.75rem;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.8);
  }

  .custom-link {
    font-size: 0.95rem;
    padding: 0.75rem 1rem !important;
    text-align: center;
    border-radius: 10px;
  }

  .custom-link:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  .btn-nav-cta {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0.75rem 1rem !important;
    margin-top: 0.5rem;
  }
}
</style>
